import React from "react";

const TermsPage: React.FC = () => {
  return (
    <div className="terms-page">
      <h2 className="uppercase">Regulamin Platformy eProdukty</h2>
      <br />
      <a 
        href="https://npws-production-cms.s3.eu-central-1.amazonaws.com/Regulamin-Platformy-eProdukty-od-15-05-2025.pdf" 
        target="_blank"
        rel="noopener noreferrer"
      >
        Regulamin dostępny tutaj
      </a>
    </div>
  );
};

export default TermsPage;
